module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier-sp.55787abb.jpg";